import PluginManager from './plugin-manager.js';
import { ShellMessageType, } from '../common/index.js';
export default class Shell {
    constructor() {
        this.pluginManager = new PluginManager();
        this.pluginEventHandler = null;
        this.messageBus = null;
    }
    setMessageBus(bus) {
        if (this.messageBus) {
            this.messageBus.cleanup();
        }
        this.messageBus = bus;
        this.messageBus.onReceive((data) => {
            if (data.type === ShellMessageType.PLUGIN_INVOCATION) {
                this.handlePluginMessage(data.message);
            }
        });
    }
    getPluginManager() {
        return this.pluginManager;
    }
    getPlugin(pluginId) {
        return this.getPluginManager().getPlugin(pluginId);
    }
    registerPlugin(pluginId, pluginApi) {
        return this.getPluginManager().registerPlugin(pluginId, pluginApi);
    }
    setPluginAvailability(pluginId, availability) {
        return this.getPluginManager().setPluginAvailability(pluginId, availability);
    }
    emitEvent(eventId, data) {
        if (this.messageBus) {
            this.messageBus.send({
                type: ShellMessageType.EVENT,
                message: {
                    eventId,
                    data,
                },
            });
        }
    }
    handlePluginMessage(data) {
        const onError = (error) => this.messageBus &&
            this.messageBus.send({
                type: ShellMessageType.PLUGIN_RESULT,
                message: {
                    uid: data.uid,
                    error,
                },
            });
        const onSuccess = (success) => this.messageBus &&
            this.messageBus.send({
                type: ShellMessageType.PLUGIN_RESULT,
                message: {
                    uid: data.uid,
                    success,
                },
            });
        this.pluginManager
            .invokePluginMethod(data)
            .then(onSuccess)
            .catch(onError);
    }
}
//# sourceMappingURL=shell.js.map